//配置全局访问接口地址
// 测试
// let commonUrl = "";
// 正式
let commonUrl = "https://api.nsyusxsq6.cc"

let baseUrl = {
    commonUrl
}
 
export default baseUrl